import Component from 'vue-class-component';
import { Prop, Watch } from "vue-property-decorator"
import moduleStore from '../../store';
import Vue from 'vue';
import { getAIGCRes } from '../../utils/api'
import { copy } from '@/utils/util'
import { toast } from '@/utils/util'
import { Toast } from "vant";
import PageState from '../../store/state';
import { FUN_DATA } from "@/constants/generateType";
import { VIP_TYPE } from "@/constants/vip"
import { judgeDeviceType } from '@/utils/device';
import memberDialog from "@/components/member-dialog/member-dialog.vue"
import LoadingAnimation from '@/components/loading-animation/loading-animation.vue'
import { customCollectEvent } from '@/utils/collect';

@Component({
  name: 'aixiaomo',
  components: {
    memberDialog,
    LoadingAnimation
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class AIXiaomoComponent extends Vue {
  @Prop() vipInfo: any;
  @Prop() articleLength: any;
  @Prop() aiText: string;
  @Prop() projectId: number;
  @Prop() selection: any;

  state: any = null;
  funcData = FUN_DATA;
  curFunId: string = '8';//当前选择的指令id
  showType: boolean = true;//显示指令类型
  showSubType: boolean = false;//显示子指令类型
  showShake: boolean = false;//是否抖动
  nextGreyImg = require("@/views/textGenerate/images/next_grey.svg");
  enterGreyImg = require("@/views/textGenerate/images/enter_grey.svg");
  backBlackImg = require("@/views/textGenerate/images/back_black.svg");
  closeBlackImg = require("@/views/textGenerate/images/close_black.svg");
  isGenerating: boolean = false
  isComplete: boolean = false
  abandonShow: boolean = false
  resultText: string = ''
  resultTextHtml: string = ''
  buyWordVisible: boolean = false
  buyMemberVisible: boolean = false
  isIOSWxMini: boolean = judgeDeviceType.isIOSWxMini
  // isIOSWxMini: boolean = false
  isAPP: boolean = judgeDeviceType.isAPP
  wordNum: number = 0
  taskId: string = ''
  timer = null
  // isExit: boolean = false
  // historyState: any = {
  //   isEditor: true,
  // }
  buycontentText: string = "你还不是会员，AI字数生成服务仅开放给会员使用，成为会员后可以购买字数使用。";
  resultOptions: Array<any> = ['替换滑选原文', '向下插入新行', '缩写', '重写', '复制结果', '放弃结果']
  get curGenerateInfo() {
    return this.funcData.filter(item => item.id == this.curFunId.split('_')[0])[0]
  }
  get subId() {
    return parseInt(this.curFunId.split('_')[1] || '-1');
  }
  get appVersion() {
    let appV = this.$store.state.appVersion
    if (appV) {
      return parseInt(appV.replace(/\./g, ''))
    } else {
      return 0
    }
  }
  abortAIGCController = null
  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
  }
  // get buyWordContent() {
  //   return `本次生成字数范围可能大于 ${this.getFilterWordLen(this.aiText)}字，当前剩余可用字数 ${this.vipInfo.wordNum} 字，为保障正常使用，请前往购买字数。`
  // }
  get buyWordContent() {
    return `本次生成字数范围可能大于 ${this.getFilterWordLen(this.aiText)}字，当前剩余可用字数 ${this.vipInfo.wordNum} 字。`
  }


  toastShake() {
    this.showShake = true;
    setTimeout(() => {
      this.showShake = false;
    }, 1000)
  }
  initState() {
    this.state.isAixiaomoEditor = false
    this.isGenerating = false
    this.isComplete = false
    this.resultText = ''
    this.showType = true
    this.showSubType = false
    this.abandonShow = false
  }
  selectType(item, type: number) {
    //若选择的是有子集的指令
    if (type == 0 && item.subInfos) {
      this.curFunId = item.id + '_' + 0;
      this.showSubType = true;
    } else {
      this.curFunId = item.id
      if (this.vipInfo.wordNum < this.getFilterWordLen(this.aiText)) {
        this.buyWordVisible = true
        customCollectEvent?.('wordbag_buy_popup')
        return
      }
      //准备直接触发文案生成-todo
      this.startlineGenerate();
      this.showSubType = false;
    }
    this.showType = false;
  }
  mounted() {
    // if (!this.vipInfo.aiCapacity) {
    //   this.funcData = FUN_DATA.filter((item) => {
    //     return !item.limit
    //   })
    //   this.curFunId = '2'
    // }
    this.$bus.$on('editorClick', (e) => {

      this.closeAIContent(e)
    })
    // if(!history.state||!history.state.isEditor){
    //   history.pushState(this.historyState, null, document.URL)
    // }
    // window.addEventListener('popstate', this.handlePopstate)
  }
  beforeDestroy() {
    clearTimeout(this.timer)
    // window.removeEventListener('popstate', this.handlePopstate)
  }
  //续费会员
  goToBuyVip() {
    if (window.platformSource == 'app') {
      let switchToVipPage: any = (<any>window).switchToVipPage
      switchToVipPage.postMessage("")
    } else {
      this.$navigateTo({
        url: `/pages/recharge-vip/recharge-vip?fromBtn=aiXiaomo`,
      })
    }

  }
  abortAIGC() {
    if (this.state.isAixiaomoEditor) {
      this.abortAIGCController.abort()
      this.$emit("flushVip")
    } else {
      if (this.taskId) {
        this.cancelGenerate()
      }
    }
    this.isComplete = true
    this.isGenerating = false

    customCollectEvent?.('editor_aiarticle_write_quit')
  }
  onError(res) {
    console.log(res);
    toast(res.message, 'top')
    this.initState()
  }
  streamText({ text, prevChat, status }) {
    this.resultText += text
    this.resultTextHtml= this.resultText.split("\n").join("<br>")
    let div = document.querySelector(".generate-text")
    if (div) {
      div.scrollTop = div.scrollHeight;
    }
    if (status === "completed") {
      this.isComplete = true
      this.isGenerating = false
      this.$emit("flushVip")
    }
  }
  lastUrl = document.URL
  /**
   * Generates the text based on the current generate info. 
    //切换生成状态，调用生成方法
   *
   * @return {void} 
   */
  startGenerateText(taskId: string): void {
    if (this.vipInfo.wordNum < this.getFilterWordLen(this.aiText)) {
      this.buyWordVisible = true
      return
    }
    this.isGenerating = true
    this.state.isAixiaomoEditor = true
    let data: any = this.makeRequestParam()
    data.taskId = taskId
    getAIGCRes(data, {
      onMessage: this.streamText.bind(this),
      onError: this.onError,
      abortController: this.abortAIGCController
    })
    let Obj = this.curGenerateInfo
    let destination = this.subId >= 0 ? Obj?.subInfos[this.subId]?.text : ''
    let wwid = localStorage.getItem("wwid");
    if(!wwid){
        wwid = this.vipInfo.wwid;
        localStorage.setItem("wwid",wwid);
    }
    customCollectEvent?.('editor_aiarticle_write', {
         button: this.curGenerateInfo.text + '-' + destination ,
         user_id:wwid||'',
         source:'wx'
        })
  }
  makeRequestParam() {
    let Obj = this.curGenerateInfo
    let sourceParam: any = {
      prevChat: [],
      textReplace: this.aiText,
      language: ''
    }

    if (this.subId >= 0) {
      sourceParam.destination = Obj?.subInfos[this.subId]?.text
    }
    let param: any = Obj.template(sourceParam)
    this.abortAIGCController = new AbortController()
    let data = {
      articleId: this.state.articleId,
      projectId: this.projectId,
      ww_token: this.state.ww_token,
      body: param
    }
    return data
  }

  /**
   * Closes the AI content.
   * @return {void} None - No return value.
   */
  closeAIContent(e = null): void {
    if (this.isGenerating || this.isComplete) {
      this.abandonShow = true
    } else {
      if (e) {
        this.$emit('caretMove', e)
      }
      this.$emit('closeAI', false);
      this.initState()
    }

  }

  /**
   * Calculates the length of the filtered word in the given result text.
   *
   * @param {string} resultText - The result text to filter.
   * @return {number} The length of the filtered word.
   */
  getFilterWordLen(resultText: string) {
    const foreignPunctuation = /[^\p{L}\p{N}\s]/gu;
    const whitespace = /\s/g;
    const filterWord = resultText.replace(foreignPunctuation, '').replace(whitespace, '');
    return filterWord.length;
  }
  backShowType() {
    this.showType = true;
    this.showSubType = false;
  }
  byNumber() {
    if (this.state.isWeta365) {
      return toast('小程序暂不支持，请到pc端购买')
    }
    if (this.vipInfo.type !== VIP_TYPE.SVIP) {
      this.buyWordVisible = false
      this.buyMemberVisible = true
      return
    }
    if (window.platformSource == 'app') {
      if (this.appVersion < 137) {
        toast("请升级到最新版本购买", 'top')
        return
      }
      let callMoyinAppPay: any = (<any>window).callMoyinAppPay
      callMoyinAppPay.postMessage("")

    } else {
      customCollectEvent?.('wordbag_buy')
      this.$navigateTo({
        url: "/mine-package/pages/buy-word/buy-word",
      })
    }

  }
  /**
   * Operates on the given item based on the provided index.
   *
   * @param {type} item - the item to operate on
   * @param {type} index - the index indicating the operation to perform
   * @return {type} description of return value
   */
  operateType(index: number) {
    switch (index) {
      case 0:
        //替换文案
        this.replaceText()
        break
      case 1:
        //插入新行
        this.insertNewLine()
        break
      case 2:
        //缩写
        this.isComplete = false
        this.abridge()
        break
      case 3:
        //重写
        this.resultText = ''
        this.isComplete = false
        this.startlineGenerate()
        break
      case 4:
        //复制文案
        copy(this.resultText).then(() => {
          toast("内容已复制");
        });
        this.initState()
        this.$emit('closeAI', false)
        break
      case 5:
        //放弃结果
        this.abandonShow = true
        break
    }
    let wwid = localStorage.getItem("wwid");
    if(!wwid){
        wwid = this.vipInfo.wwid;
        localStorage.setItem("wwid",wwid);
    }
    customCollectEvent?.('editor_aiarticle_write', { 
        button: this.resultOptions[index],
        user_id:wwid||'' ,
        source:'wx'
    }) 
  }
  //缩写
  abridge() {
    this.resultText = ''
    this.curFunId = '2'
    //准备直接触发文案生成-todo
    this.startlineGenerate();
  }
  replaceText() {
    let fragment = this.createFragDom(this.resultText)
    let range = this.selection.range
    range.deleteContents();
    range.insertNode(fragment);

    this.$emit('closeAI', fragment)
    this.initState()
    let editorText = document.querySelector('.editor').textContent;
    if (this.getFilterWordLen(editorText) > 5000) {
      toast("文案超过5000字，请编辑后保存")
    }
  }

  insertNewLine() {
    let fragment = this.createFragDom(this.resultText)
    let range = this.selection.range.cloneRange()
    range.collapse(false)
    range.insertNode(fragment);
    this.$emit('closeAI', fragment)
    this.initState()
    let editorText = document.querySelector('.editor').textContent;
    if (this.getFilterWordLen(editorText) > 5000) {
      toast("文案超过5000字，请编辑后保存")
    }
  }

  createFragDom(text) {
    let textList = text.split('\n')
    let fragment = document.createDocumentFragment();
    textList.forEach((item) => {
      var div = document.createElement("div");
      div.textContent = item;
      fragment.appendChild(div);
    })
    return fragment
  }
  // @Watch('abandonShow')
  // bottomNavVisible(bool: boolean) {
  //   if (bool == false) {
  //     this.isExit=false
  //   }
  // }
  abandonText() {
    if (this.isGenerating) {
      this.abortAIGC()
    }
    this.$emit('closeAI', false)
    this.initState()
  }
  startlineGenerate() {

    if (this.vipInfo.wordNum < this.getFilterWordLen(this.aiText)) {
      this.buyWordVisible = true
      return
    }

    this.isGenerating = true
    let data = this.makeRequestParam()
    this.$http("submitAiTask", data).then((res: any) => {
      if (res.code !== 200 || !res.data) {
        this.initState()
        toast(res.message || '生成失败')
        return
      }
      this.taskId = res.data.taskId
      this.timer = setTimeout(() => {
        this.isCancel = false;
        this.getResult(res.data.taskId)
      }, 1000)
      // window.location.href =location.protocol+"//"+location.host+ "/#/extractResult?params="+JSON.stringify(resData)
    })
      .catch((err) => {
        toast("服务出错，请稍后再试");
        this.initState()
      })
  }
  isCancel = false
  //取消任务
  async cancelTask(taskId) {
    try {
      const res = await this.$http("deleteTask", { taskId });
      // toast('ai小魔已停止');
      this.initState();
    } catch (err) {
      toast('ai小魔停止失败');
    }
    this.globalLoading.clear()
  }
  // //获取提取结果
  async getResult(taskId: string) {
    this.timer = null
    if (this.isCancel) {
      this.isCancel = false;
      this.initState();
      return;
    }
    try {
      const res = await this.$http("getTaskResult", { taskId });
      const resData = res.data;
      if (resData.status == 1) {
        this.startGenerateText(taskId)
      } else if (resData.status == 0) {
        this.timer = setTimeout(() => {
          this.getResult(taskId);
        }, 1000);
      } else {
        this.initState();
        let errorMessage = res.message || '服务出错，请稍后再试';
        toast(errorMessage);
        console.log(res);
      }
    } catch (err) {
      this.initState();
      let errorMessage = err.message || '服务出错，请稍后再试';
      toast(errorMessage);
      console.log(err);

    }
  }
  globalLoading = null
  cancelGenerate() {
    this.globalLoading = Toast.loading({
      message: '取消中...',
      forbidClick: true,
      duration: 200
    });
    this.cancelTask(this.taskId);
    clearTimeout(this.timer)
    this.isCancel = true;
    customCollectEvent('tools_aiarticle_lineup')
  }
}

